import { UtityService } from 'src/app/service/utity.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import pageSettings from '../config/page-settings';
import { AuthService } from '../auth.service';
import { ConnectBackendService } from '../service/connect-backend.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Organization } from '../main/setting/organization/organization.model';
import Swal from 'sweetalert2';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Location } from '@angular/common';
import { th } from 'date-fns/locale';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  bg;
  bgList;
  app;
  pageSettings = pageSettings;

  loginForm: FormGroup;
  org_form: FormGroup;
  org_model: Organization;
  headers = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
  constructor(
    private router: Router,
    private service: AuthService,
    private formBuilder: FormBuilder,
    private api: ConnectBackendService,
    private http: HttpClient,
    private _location: Location,
    private utity: UtityService
    // private _snackBar: MatSnackBar,
  ) {
    this.org_model = new Organization({});
    this.pageSettings.pageEmpty = true;
    this.org_form = this.formBuilder.group(this.org_model);
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });

  }

  ngOnDestroy() {
    this.pageSettings.pageEmpty = false;
  }

  ngOnInit() {

    this.bg = '/assets/img/login-bg/login-bg-17.jpg';
    this.bgList = [
      { bg: '/assets/img/login-bg/login-bg-17.jpg', active: true },
      { bg: '/assets/img/login-bg/login-bg-16.jpg' },
      { bg: '/assets/img/login-bg/login-bg-15.jpg' },
      { bg: '/assets/img/login-bg/login-bg-14.jpg' },
      { bg: '/assets/img/login-bg/login-bg-13.jpg' },
      { bg: '/assets/img/login-bg/login-bg-12.jpg' }
    ];
    this.check_login();
  }


  check_login() {
    if (localStorage.getItem('JposToken') != null) {
      this.router.navigate(['/work/sale']);
    }
  }

  changeBg(list) {
    this.bg = list.bg;
    list.active = true;

    for (const bList of this.bgList) {
      if (bList !== list) {
        bList.active = false;
      }
    }
  }

  async loadDelimiter(): Promise<void> {
    const load$ = this.utity.getDelimiter();
    const result: any = await lastValueFrom(load$);

    if (result) {
      if (result.data.use_delimiter === 'yes') {
        localStorage.setItem('delimiter', '1.' + result.data.delimiter + '-' + result.data.delimiter);
      } else {
        localStorage.setItem('delimiter', '1.0-0');
      }
      if (result.data.use_delimiter_qty === 'yes') {
        localStorage.setItem('delimiter_qty', '1.' + result.data.delimiter_qty + '-' + result.data.delimiter_qty);
      } else {
        localStorage.setItem('delimiter_qty', '1.0-0');
      }
    }
    return;
  }

  onSubmit() {
    this.http.post(`${this.api.url}/login`, this.loginForm.getRawValue(), this.headers).subscribe( async (resp: any) => {

      if (resp.status === 'success') {
        if (resp.data.num_expire > 0) {
          // console.log(resp.data);
          localStorage.setItem('JposToken', resp.data.token);
          localStorage.setItem('user_id', resp.data.user_id);
          localStorage.setItem('name', resp.data.name);
          localStorage.setItem('level', resp.data.level);
          localStorage.setItem('company_id', resp.data.company_id);
          localStorage.setItem('branch_id', resp.data.branch_id);
          localStorage.setItem('branch_name', resp.data.branch_name);
          localStorage.setItem('custom_menu_id', resp.data.custom_menu_id);
          localStorage.setItem('num_expire', resp.data.num_expire);
          localStorage.setItem('branch_vat', resp.data.branch_vat);
          localStorage.setItem('productIdStart', resp.data.productIdStart);
          localStorage.setItem('fifo', resp.data.fifo);
          localStorage.setItem('logo', resp.data.logo);

         await this.loadDelimiter();


          if (resp.data.level === 'admin') {
            this.router.navigate(['/work/sale']);
          } else if (resp.data.level === 'custom') {
            this.router.navigate([resp.data.url]);
          }
          else {
            this.router.navigate(['/work/sale']);
          }



          if (resp.manyDevice) {
            Swal.fire('คำเตือน', 'พบการเข้าระบบในอุปกรณ์อื่น', 'warning');
          }

        } else {
          Swal.fire('วันใช้งานของท่านหมดเเล้ว', 'กรุณาติดต่อฝ่ายบริการลูกค้า Line: @dir7307j หรือ โทร 094-8565087', 'error');
        }

      } else {
        Swal.fire('ไม่สามารถเข้าสู่ระบบ', 'กรุณาตรวจสอบ Username และ Password', 'error');
      }
    }, error => {
      console.log(error);
      Swal.fire('เกิดข้อผิดพลาด', 'โปรดติดต่อเจ้าหน้าที่เพื่อทำการตรวจสอบ', 'error');
    });
  }

  // loadOrganization(){
  //   this.api.get("/settings/company/" + localStorage.getItem('company_id')).subscribe((res) => {
  //     this.org_model = res;
  //     this.org_form.patchValue(this.org_model);
  //     console.log(this.org_form);

  // });
  // }

}
